module.exports = __webpack_public_path__ + "images/circle-2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/circle-2.png
// module id = 816
// module chunks = 106